module.exports = __webpack_public_path__ + "media/images/avatar-76b18c362f32faa4e9d609a7f1f2d52c.png";